export const CATATLOG_COUNT = "CATATLOG_COUNT"
export const IS_LOADING = "IS_LOADING"
export const UPDATE_COUNT = "UPDATE_COUNT"
